<template>
  <div class="container-fluid">
    <div class="row md-12">
      <SupportEndpoints />
    </div>
    <div class="row md-12">
      <ProductAgencySetting />
    </div>
    <div class="row md-12">
      <LogSearcher />
    </div>
  </div>
</template>

<script>
import LogSearcher from "./LogSearcher.vue";
import ProductAgencySetting from "./billing/ProductAgencySetting.vue";
import SupportEndpoints from "./SupportEndpoints.vue";

export default {
  components: {
    LogSearcher,
    ProductAgencySetting,
    SupportEndpoints,
  },
};
</script>

<style>
.hl__info-table {
  width: 100%;
  max-width: 100%;
}
.hl__info-table td {
  vertical-align: top;
}
.outer-box {
  text-align: center;
  background-color: #fffffff2;
  padding: 16px;
  border-radius: 8px;
  margin: 32px auto 0;
}
.inner-box {
  border-top: 1px dashed #888;
  margin: 16px;
  padding-top: 16px;
  /* padding: 16px; */
}
.btn {
  box-shadow: -2px -2px 12px #0000001d, 2px 2px 12px #0000001d !important;
}
.form-control {
  box-shadow: -2px -2px 8px #0000000d, 2px 2px 8px #0000000d !important;
}
.box-subtitle {
  color: #888;
  margin: auto 8px;
  font-size: 14px;
}
</style>
